module.exports = __webpack_public_path__ + "static/img/ngzg_new.964f832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngzg_new.png
// module id = Ez8k
// module chunks = 3